import { isDefined } from "@clipboard-health/util-ts";
import type { WorkerCredentialSharedMessageProps } from "@src/appV2/Chat/type";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { useChartingContextData } from "@src/appV2/Shifts/Shift/useGetChartingCredentials";

import { ChatWidgetWrapper } from "../../redesign/Chat/ChatWidgetWrapper";
import { WorkerCredentialSharedMessageCard } from "./WorkerCredentialSharedMessageCard";

export function WorkerCredentialSharedMessage(props: WorkerCredentialSharedMessageProps) {
  const { message, workplaceId, workerId } = props;
  const { data } = message;
  const messageData: unknown = isDefined(data) ? JSON.parse(data) : undefined;
  const workplaceName: string | undefined =
    typeof messageData === "object" &&
    isDefined(messageData) &&
    "workplaceName" in messageData &&
    typeof messageData.workplaceName === "string"
      ? messageData.workplaceName
      : undefined;

  const systemMessage = isDefined(workplaceName)
    ? `${workplaceName} shared charting login with you`
    : "A charting login has been shared with you";

  const {
    data: chartingCredential,
    isLoading,
    isError,
    chartingCredentialsModalState,
  } = useChartingContextData();

  if (isError) {
    logError(APP_V2_APP_EVENTS.SHARED_CREDENTIALS_MESSAGE_RENDER_FAILURE, {
      error: new Error("Failed to render shared credentials message"),
      metadata: {
        workerId,
        workplaceId,
        messageId: message.messageId,
      },
    });
    return null;
  }

  return (
    <ChatWidgetWrapper headerText={systemMessage}>
      <WorkerCredentialSharedMessageCard
        workerId={workerId}
        workplaceId={workplaceId}
        chartingCredential={chartingCredential}
        isLoadingCredentials={isLoading}
        chartingCredentialsModalState={chartingCredentialsModalState}
      />
    </ChatWidgetWrapper>
  );
}
